// Copyright 2026 TokenLat. Licensed under the Apache License, Version 2.0.
import { Modal } from '@coze-arch/coze-design';
import {
  modelCreationErrorState,
  modelSelectionMessage,
  openTokenLatSettings,
} from '@coze-arch/bot-api/model-catalog';

export function showModelCreationGuidance(error: unknown): boolean {
  const state = modelCreationErrorState(error);
  if (!state) {
    return false;
  }
  const zh =
    typeof navigator !== 'undefined' && navigator.language.startsWith('zh');
  Modal.confirm({
    title: zh ? '请先配置可用模型' : 'Configure an available model',
    content: `${modelSelectionMessage(state)} ${zh ? '已保留填写内容，配置完成后请返回并再次点击确认创建。' : 'Your form is preserved. Return and confirm creation after configuration.'}`,
    okText: zh ? '去配置令牌' : 'Configure token',
    cancelText: zh ? '暂不配置' : 'Not now',
    onOk: openTokenLatSettings,
  });
  return true;
}
